import { FireAlertIcon } from './FireAlertIcon';

/**
 * author: Colton Wiscombe
 * id 69B65938-BBEB-4E19-9D12-3924EEAAACF0
 * name fire-alert
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fire-alert.svg
 * tags
 * - Alert / Error 
 * - Home Automation 
 */
export const FlameAlertIcon = FireAlertIcon;
export default FlameAlertIcon